export const isWhatPercentOf = (numA: number, numB: number): number => {
    return (numA / numB) * 100;
};
